import styled from "styled-components";

import { IconControl } from "ds/Button";

export const ContextWrapper = styled.div`
  box-sizing: border-box;
  position: relative;
`;

export const ReloadButton = styled(IconControl)`
  position: absolute;
  top: 4px;
  right: 4px;
`;
